import { unitMapping } from 'lib/style';
import { Color } from 'style/types';

type Props = {
  color?: Color;
  size?: keyof typeof unitMapping;
};

export const AddCards = ({ color, size = 2 }: Props) => {
  return (
    <svg
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1881 6.79986C14.0411 6.72033 13.8853 6.6551 13.7224 6.60603L14.1629 4.96216L9.47018 3.70476L10.6558 8.12965C10.5551 8.40072 10.5001 8.69399 10.5001 9.00011V9.50011H10.0001C8.6194 9.50011 7.50011 10.6194 7.50011 12.0001C7.50011 12.3858 7.58744 12.751 7.74339 13.0772C8.14578 13.9188 9.00506 14.5001 10.0001 14.5001H10.5001V14.8511L5.16675 13.4221L5.19894 13.3019L4.82187 13.403C4.58957 13.4652 4.35446 13.4403 4.15123 13.3483C3.88773 13.2291 3.67782 12.997 3.59712 12.6958L1.00893 3.03659C0.86599 2.50312 1.18257 1.95479 1.71604 1.81185L7.51159 0.258932C8.04506 0.11599 8.5934 0.432572 8.73634 0.966038L9.02189 2.03173L15.0341 3.64269C15.5675 3.78563 15.8841 4.33396 15.7412 4.86743L15.0263 7.53536C14.8064 7.23165 14.5198 6.97934 14.1881 6.79986ZM12 9C12 8.44772 12.4477 8 13 8C13.5523 8 14 8.44772 14 9V11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H14V15C14 15.5523 13.5523 16 13 16C12.4477 16 12 15.5523 12 15V13H10C9.44772 13 9 12.5523 9 12C9 11.4477 9.44771 11 10 11H12V9Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
};
